<template>
  <div class="form__wrapper col" id="form__wrapper">
    <img
      class="flowers__bg"
      src="../assets/images/11/flowers_desktop.png"
      alt="Kwiatek"
    />
    <div class="form__box">
      <ProgressBar v-if="showProgressBar" v-bind:counterData="counterNum" />

      <div class="form__bottom">
        <img
          class="butterfly"
          src="../assets/images/11/motyl_2.png"
          alt="Moty;"
        />
        <img class="bbee" src="../assets/images/11/bee.png" alt="Pszczółka" />
        <div
          class="form__header text-center"
          v-html="content.data.form_invitation.header_1"
        ></div>

        <form>
          <div
            class="d-flex align-items-center justify-content-center form__counterwrap"
          >
            <div class="d-flex">
              <div class="form__counterbtn--width">
                <img
                  class="form__counterbtn form__counterbtn--up"
                  @click="counterUp"
                  src="../assets/images/plus.svg"
                  alt="pszczoła"
                />
                <img
                  class="form__counterbtn form__counterbtn--down"
                  @click="counterDown"
                  src="../assets/images/minus.svg"
                  alt="pszczoła"
                />
              </div>

              <input
                class="form__input"
                v-model="value"
                type="text"
                name="bee-counter"
              />
            </div>
            <img
              class="form__bee-small d-inline"
              src="../assets/images/10/beeequal.svg"
              alt="pszczoła"
            />
            <span class="d-inline form__legend-info">= 2 PLN</span>
          </div>
          <div class="form__legend">
            <div
              v-if="content.data.payment.showSinglePaymentCms"
              class="form__legend--title"
              v-html="content.data.form_invitation.chose_type"
              :class="{
                'text-danger':
                  selectAdoptionType && !subscription && !oneTimePayment,
              }"
            ></div>

            <div
              v-else
              v-html="
                content.data.form_invitation.chose_type_when_only_subscription
              "
              class="pt-1"
              :class="{
                'text-danger':
                  selectAdoptionType && !subscription && !oneTimePayment,
              }"
            ></div>
            <div
              class="form__descset d-lg-block"
              v-if="content.data.test_ab.active"
            >
              <Ab
                @sample="(value) => (test_ab_content = value)"
                :weight="{ test_ab_contentA: 50, test_ab_contentB: 50 }"
              >
                <span
                  slot="test_ab_contentA"
                  v-html="content.data.test_ab.form_invitation_a"
                ></span>
                <span
                  slot="test_ab_contentB"
                  v-html="content.data.test_ab.form_invitation_b"
                ></span>
              </Ab>
            </div>
            <div
              class="form__descset d-lg-block"
              v-else
              v-html="content.data.form.desktop_info_tooltip"
            ></div>
            <div class="form__choice d--flex">
              <div class="form__group">
               
                <div
                  class="form__check form__check--subscription"
                  v-bind:class="{
                    active: subscription,
                    'single-only': !content.data.payment.showSinglePaymentCms,
                  }"
                  @click="(subscription = true), showAnimationFn()"
                >
                  <div
                    class="form__tooltip d-none d-lg-inline"
                    v-if="showTooltipButonSub"
                  >
                    <div
                      class="form__tooltip-close"
                      @click="showTooltipButonSubFn"
                    >
                      x
                    </div>
                    <div
                      class="form__tooltip-text"
                      v-html="content.data.form.tooltip_form"
                    ></div>
                  </div>
                  <h6 class="form__level form__level">
                    <span v-html="content.data.form.btn_subscription"></span>
                  </h6>
                </div>
                <div
                class="form__check"
                v-bind:class="{ active: !subscription && oneTimePayment }"
                @click="
                  subscription = false;
                  oneTimePayment = true;
                "
                v-if="content.data.payment.showSinglePaymentCms"
              >
                <h6
                  class="form__level"
                  v-html="content.data.form.btn_single"
                ></h6>
              </div>
              </div>
            </div>

            <div
              class="form__submit"
              v-html="content.data.form_invitation.btn_cta"
              @click="checkPaymentType"
            ></div>

            <b-modal
              v-model="modalShow"
              id="modal-payment"
              hide-footer
              hide-header
              size="lg"
              body-class="p-0"
            >
              <div class="d-block text-center">
                <div>
                  <div>
                    <ul
                      class="nav nav-tabs"
                      v-if="!this.hideSingle"
                      v-show="content.data.payment.showSinglePaymentCms"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link single"
                          v-html="content.data.form.btn_single_modal"
                          v-bind:class="{ active: oneTimePayment }"
                          @click="oneTimePayment = true"
                        ></a>
                      </li>
                      <li class="nav-item modal__tooltip">
                        <div
                          class="modal__tooltiptext"
                          v-html="
                            content.data.form_invitation.tooltip_invitation
                          "
                        ></div>
                        <a
                          role="tab"
                          class="nav-link reg"
                          v-html="content.data.form.btn_subscription_modal"
                          v-bind:class="{ active: !oneTimePayment }"
                          @click="oneTimePayment = false"
                        ></a>
                      </li>
                    </ul>
                    <div class="modal__common">
                      <h2
                        class="modal__title"
                        v-html="content.data.form.subscription_modal_title"
                        v-if="!oneTimePayment && !content.data.test_ab.active"
                      ></h2>
                      <h2
                        class="modal__title"
                        v-if="!oneTimePayment && content.data.test_ab.active"
                      >
                        <Ab
                          @sample="(value) => (test_ab_content = value)"
                          :weight="{
                            test_ab_contentA: 50,
                            test_ab_contentB: 50,
                          }"
                        >
                          <span
                            slot="test_ab_contentA"
                            v-html="
                              content.data.test_ab.modal_title_subscription_a
                            "
                          ></span>
                          <span
                            slot="test_ab_contentB"
                            v-html="
                              content.data.test_ab.modal_title_subscription_b
                            "
                          ></span>
                        </Ab>
                      </h2>
                      <div
                        class="modal__subtitle"
                        v-html="content.data.form.subscription_modal_subtitle"
                        v-if="!oneTimePayment"
                      ></div>
                      <h2
                        class="modal__title"
                        v-if="oneTimePayment && content.data.test_ab.active"
                      >
                        <Ab
                          @sample="(value) => (test_ab_content = value)"
                          :weight="{
                            test_ab_contentA: 50,
                            test_ab_contentB: 50,
                          }"
                        >
                          <span
                            slot="test_ab_contentA"
                            v-html="content.data.test_ab.modal_title_single_a"
                          ></span>
                          <span
                            slot="test_ab_contentB"
                            v-html="content.data.test_ab.modal_title_single_b"
                          ></span>
                        </Ab>
                      </h2>
                      <h2
                        class="modal__title"
                        v-html="content.data.form.single_modal_title"
                        v-if="!content.data.test_ab.active && oneTimePayment"
                      ></h2>
                      <div
                        class="modal__subtitle"
                        v-if="oneTimePayment"
                        v-html="content.data.form.single_modal_subtitle"
                      ></div>
                    </div>
                    <b-form
                      id="form-modal"
                      class="bg-white form__core"
                      @change="changedForm"
                    >
                      <div
                        class="d-flex align-items-center justify-content-center py-4 pt-lg-2 mx--1"
                      >
                        <div class="d-flex">
                          <div class="form__counterbtn--width">
                            <img
                              class="form__counterbtn form__counterbtn--up"
                              @click="counterUp"
                              src="../assets/images/plus.svg"
                              alt="pszczoła"
                            />
                            <img
                              class="form__counterbtn form__counterbtn--down"
                              @click="counterDown"
                              src="../assets/images/minus.svg"
                              alt="pszczoła"
                            />
                          </div>
                          <input
                            class="form__input"
                            v-model="value"
                            type="text"
                            name="bee-counter"
                            id="bee-counter-show"
                          />
                        </div>
                        <img
                          class="form__multiple"
                          src="../assets/images/10/beforebee.svg"
                          alt="pszczoła"
                        />
                        <img
                          class="form__bee"
                          src="../assets/images/i_bee-times.svg"
                          alt="pszczoła"
                        />
                        <span class="form__amount">
                          <span class="px-1">=</span> {{ amount }} PLN</span
                        >
                        <input
                          v-model="form.amount"
                          :v="$v.form.amount"
                          type="hidden"
                        />
                      </div>
                      <div v-if="$v.form.amount.$dirty">
                        <div
                          v-html="content.data.form.errors.min_regular"
                          class="text-danger text-danger-min"
                          v-if="!$v.form.amount.minValue && subscription"
                        ></div>
                        <div
                          v-html="content.data.form.errors.min_single"
                          class="text-danger text-danger-min"
                          v-if="!$v.form.amount.minValue && !subscription"
                        ></div>
                        <div
                          class="text-danger"
                          v-html="content.data.form.errors.max_regular"
                          v-if="!$v.form.amount.maxValue && !subscription"
                        ></div>
                      </div>
                      <div
                        class="form__details"
                        v-if="oneTimePayment"
                        v-html="content.data.form.single_modal_title"
                      ></div>
                      <div
                        class="form__details"
                        v-if="!oneTimePayment"
                        v-html="content.data.form.subscription_modal_intro"
                      ></div>
                      <div class="row">
                        <div class="col-lg-6">
                          <b-form-group>
                            <b-form-input
                              id="name"
                              autocomplete="given-name"
                              v-on:click="onClickElement('name')"
                              v-model="form.name"
                              :v="$v.form.name"
                              required
                              placeholder="Imię*"
                              :class="{ 'is-invalid': $v.form.name.$error }"
                            ></b-form-input>
                            <div
                              v-if="$v.form.name.$dirty"
                              class="text-danger-name"
                            >
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.name.required"
                              >
                                <small>Pole jest wymagane</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.name.minLength"
                              >
                                <small>
                                  Minimalna długość imienia to 3 znaki
                                </small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.name.maxLength"
                              >
                                <small>
                                  Zbyt długie imię. Maksymalna długość to 255
                                  znaków</small
                                >
                              </div>
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-lg-6">
                          <b-form-group>
                            <b-form-input
                              id="surname"
                              v-on:click="onClickElement('surname')"
                              autocomplete="family-name"
                              v-model="form.surname"
                              required
                              placeholder="Nazwisko*"
                              :class="{ 'is-invalid': $v.form.surname.$error }"
                            ></b-form-input>
                            <div v-if="$v.form.surname.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.surname.required"
                              >
                                <small>Pole jest wymagane</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.surname.minLength"
                              >
                                <small
                                  >Minimalna długość nazwiska to 3 znaki</small
                                >
                              </div>
                              <div
                                class="text-danger"
                                v-if="!$v.form.surname.maxLength"
                              >
                                Zbyt długie nazwisko. Maksymalna długość to 255
                                znaków
                              </div>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <b-form-group>
                            <b-form-input
                              id="email"
                              :v="$v.form.email"
                              v-model="form.email"
                              v-on:click="onClickElement('email')"
                              type="email"
                              required
                              placeholder="Email*"
                              :class="{ 'is-invalid': $v.form.email.$error }"
                            ></b-form-input>
                            <div v-if="$v.form.email.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.email.required"
                              >
                                <small>Pole jest wymagane</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.email.email"
                              >
                                <small>Wpisz poprawny email</small>
                              </div>
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-lg-6">
                          <b-form-group>
                            <b-form-input
                              id="name"
                              autocomplete="phone"
                              v-model="form.phone"
                              v-on:click="onClickElement('name')"
                              v-on:keypress="onEnterPhone"
                              v-on:blur="onBlurPhone"
                              placeholder="Telefon"
                            ></b-form-input>
                            <div v-if="form.phone != ''" class="text-bee">
                              <small
                                v-html="content.data.form.agreement_2"
                              ></small>
                            </div>
                          </b-form-group>
                        </div>
                      </div>

                      <b-form-group id="agreementData" class="text-left">
                        <b-form-checkbox-group
                          v-model="form.agreementData"
                          id="agreementData"
                          v-on:click="onClickElement('agreementData')"
                          class="form__checkboxes"
                          :class="{
                            'is-invalid': $v.form.agreementData.$error,
                          }"
                        >
                          <b-form-checkbox value="agreementData">
                            <div
                              class="pt-1"
                              v-html="content.data.form.agreement_1"
                            ></div>
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                        <div v-if="$v.form.agreementData.$dirty">
                          <div
                            class="text-danger text-left"
                            v-if="!$v.form.agreementData.required"
                          >
                            <small
                              v-html="content.data.form.agreement_7"
                            ></small>
                          </div>
                        </div>
                      </b-form-group>
                      <b-form-group
                        id="agreement"
                        :label="content.data.form.agreement_5"
                        label-for="agreement"
                        class="form__checkboxes text-left"
                      >
                        <b-form-checkbox-group
                          v-model="form.contactType"
                          id="agreement"
                        >
                          <b-form-checkbox
                            v-on:click="onClickElement('agreementEmail')"
                            value="agreementEmail"
                            class="form__checkboxes"
                            ><span
                              v-html="content.data.form.agreement_3"
                            ></span>
                          </b-form-checkbox>
                          <b-form-checkbox
                            value="agreementPhone"
                            v-on:click="onClickElement('agreementPhone')"
                            ><span
                              v-html="content.data.form.agreement_4"
                            ></span>
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                      <div
                        class="d-flex justify-content-center justify-content-lg-between flex-column flex-lg-row align-items-center"
                      >
                        <div
                          class="form__payment"
                          v-html="content.data.form.agreement_8"
                        ></div>
                        <div class="form__pay--width">
                          <div
                            class="form__pay form__pay--blik"
                            @click="onBlikPay"
                            v-if="oneTimePayment && showBlik"
                          >
                            <img
                              src="../assets/images/blik.svg"
                              alt="Blik logo"
                              class="form__blik"
                            />
                          </div>
                        </div>

                        <div
                          class="form__pay form__pay--payu"
                          @click="onCardPay"
                          v-if="subscription"
                        >
                          <img
                            src="../assets/images/payu.png"
                            alt="Payu logo"
                            class="form__payu"
                            id="payu-subscription-image"
                          />
                        </div>
                        <div
                          id="onSubmitButton"
                          class="form__pay form__pay--payu"
                          v-if="oneTimePayment"
                          @click="onSubmit"
                          v-bind:class="{ inactive: showBlikNum }"
                        >
                          <img
                            src="../assets/images/payu.png"
                            alt="Payu logo"
                            class="form__payu"
                            id="payu-single-image"
                          />
                        </div>
                        <div
                          class="form__pay form__pay--paypal"
                          @click="onSubmit"
                          v-bind:class="{
                            inactive: showCreditCard || showBlikNum,
                          }"
                        >
                          <img
                            src="../assets/images/PayPal.svg"
                            alt="Paypal logo"
                            id="paypal-image"
                            @click="showCreditCard = false"
                          />
                        </div>
                      </div>
                      <div v-if="showBlikNum && oneTimePayment">
                        <div class="row py-4">
                          <div
                            class="col-lg-4 d-flex align-items-center flex-column justify-content-center"
                          >
                            <b-form-input
                              id="blik"
                              v-on:click="onClickElement('blik')"
                              v-model="form.blik"
                              required
                              placeholder="Podaj Kod Blik"
                              class="mt-1 d-block text-center"
                              autofocus
                              v-on:keypress="onEnterBlik"
                              :class="{ 'is-invalid': $v.form.blik.$error }"
                            ></b-form-input>
                            <div class="w-100" v-if="$v.form.blik.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.blik.required"
                              >
                                <small>Padaj kod blik</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="
                                  !$v.form.blik.mustBeNumber ||
                                  !$v.form.blik.mustBe6
                                "
                              >
                                <small>Podaj poprawny kod Blik</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="form__submit" @click="payByBlik()">
                              ADOPTUJĘ
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="showCreditCard && subscription">
                        <div class="row pt-4 pb-2">
                          <div
                            class="col small text-left"
                            v-html="content.data.form.card_info"
                          ></div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <b-form-group>
                              <b-form-input
                                id="pcard"
                                v-on:click="onClickElement('pcard')"
                                class="payu-card-number"
                                v-model="form.pcard"
                                required
                                placeholder="Numer karty"
                                autocomplete="cc-number"
                                v-on:keypress="onEnterCreditCard"
                                v-on:blur="onBlur"
                                autofocus
                              ></b-form-input>
                              <div v-if="$v.form.pcard.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.pcard.required"
                                >
                                  <small>Numer karty jest wymagany</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="
                                    !$v.form.pcard.mustBe16 ||
                                    !$v.form.pcard.mustBeNumber
                                  "
                                >
                                  <small>Podaj poprawny numer</small>
                                </div>
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-lg-4">
                            <b-form-group>
                              <b-form-input
                                id="cvv"
                                v-on:click="onClickElement('cvv')"
                                class="payu-card-cvv"
                                v-model="form.cvv"
                                required
                                placeholder="CVV"
                                autocomplete="cc-csc"
                                v-on:keypress="onEnterCVV"
                              ></b-form-input>
                              <div v-if="$v.form.cvv.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.cvv.required"
                                >
                                  <small>Numer jest wymagany</small>
                                </div>

                                <div
                                  class="text-danger text-left"
                                  v-if="
                                    !$v.form.cvv.minLength ||
                                    !$v.form.cvv.maxLength
                                  "
                                >
                                  <small
                                    >Wpisz poprawny kod CVV. Znajdziesz go z
                                    tyłu karty</small
                                  >
                                </div>
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-4">
                            <b-form-group>
                              <b-form-input
                                id="cmm"
                                autocomplete="cc-exp-month"
                                class="payu-card-expm"
                                v-model="form.cmm"
                                required
                                placeholder="MM"
                                v-on:click="onClickElement('cmm')"
                                v-on:keypress="onEnterMM"
                              ></b-form-input>
                              <div v-if="$v.form.cmm.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.cmm.required"
                                >
                                  <small>Miesiąc jest wymagany</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="
                                    !$v.form.cmm.minLength ||
                                    !$v.form.cmm.maxLength
                                  "
                                >
                                  <small>Wpisz poprawne dane</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.cmm.max12"
                                >
                                  <small>Podaj poprawny miesiąc</small>
                                </div>
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-lg-4">
                            <b-form-group>
                              <b-form-input
                                id="rrrr"
                                class="payu-card-expy"
                                autocomplete="cc-exp-year"
                                v-on:click="onClickElement('rrrr')"
                                v-model="form.cyy"
                                required
                                placeholder="RRRR"
                                v-on:keypress="onEnterYY"
                              ></b-form-input>

                              <div v-if="$v.form.cyy.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.cyy.required"
                                >
                                  <small>Rok jest wymagany</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="
                                    !$v.form.cyy.minLength ||
                                    !$v.form.cyy.maxLength
                                  "
                                >
                                  <small>Wpisz poprawne dane</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.cyy.checkYear"
                                >
                                  <small>Podaj poprawny rok</small>
                                </div>
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div
                              id="payuAgreement"
                              role="group"
                              tabindex="-1"
                              class="form__checkboxes text-left bv-no-focus-ring"
                            >
                              <div
                                class="custom-control custom-control-inline custom-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  name="payuAgreement"
                                  v-model="form.payuAgreement"
                                  autocomplete="off"
                                  class="custom-control-input payu-agreement"
                                  value="true"
                                  id="__BVID__108"
                                /><label
                                  class="custom-control-label"
                                  for="__BVID__108"
                                  v-html="content.data.form.agreement_6"
                                >
                                </label>
                              </div>
                            </div>

                            <div v-if="$v.form.payuAgreement.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.payuAgreement.required"
                              >
                                <small>Zgoda jest wymagana</small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row py-3">
                          <div class="col">
                            <div
                              v-html="content.data.form.btn_cta_modal"
                              class="form__submit mb-0"
                              id="payByCard"
                              @click="payByCard()"
                            ></div>
                          </div>
                        </div>
                        <div class="row pb-3">
                          <div class="col">
                            <img
                              src="../assets/images/cards.png"
                              alt="credit card logo"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col text-left">
                            <small>
                              {{ content.data.form.legalNotice_1 }}
                              <a
                                :href="`mailto: ${content.data.form.legalNotice_5}`"
                                :title="content.data.form.legalNotice_5"
                                >{{ content.data.form.legalNotice_5 }}</a
                              >
                              {{ content.data.form.legalNotice_2 }}
                              <a
                                :href="`tel:48${content.data.form.legalNotice_4}`"
                                :title="content.data.form.legalNotice_4"
                                >{{ content.data.form.legalNotice_4 }}</a
                              >
                              {{ content.data.form.legalNotice_3 }}
                            </small>
                          </div>
                        </div>
                      </div>
                    </b-form>
                  </div>
                  <div
                    class="form__legal-notice"
                    v-html="content.data.form.legalNotice_6"
                  ></div>
                </div>
              </div>
            </b-modal>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<!-- FOR OPEN PAYU -->
<script></script>

<script>
import axios from "axios";
import CountDown from "./CountDown.vue";
import ProgressBar from "./ProgressBar.vue";
import Animation from "./Animation.vue";
import Ab from "vue-ab";

import {
  email,
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

export default {
  name: "Form",
  inject: ["content"],
  data() {
    return {
      title: "Formularz",
      value: "25",
      subscription: true,
      modalShow: false,
      amount: 50,
      counter: 0,
      counterNum: 0,
      remarketingWelcome: false,
      oneTimePayment: false,
      showAnimation: false,
      showProgressBar: false,
      showCreditCard: false,
      hideSingle: false,
      showBlik: true,
      showBlikNum: false,
      selectAdoptionType: false,
      windowWidth: 0,
      showVideo: false,
      showTooltipButonSub: true,
      abVersion: "testA",
      form: {
        inviteToPay: new URLSearchParams(location.search).get("inviteToPay"),
        inviteToSinglePayment: new URLSearchParams(location.search).get(
          "inviteToSinglePayment"
        ),
        // utmSource: new URLSearchParams(location.search).get("utm_source"),
        // utmMedium: new URLSearchParams(location.search).get("utm_medium"),
        // utmCampaign: new URLSearchParams(location.search).get("utm_campaign"),
        // utmTerm: new URLSearchParams(location.search).get("utm_term"),
        // utmContent: new URLSearchParams(location.search).get("utm_content"),
        fundraiser: new URLSearchParams(location.search).get("fundraiser"),
        tag: this.abVersion,
        email: "",
        name: "",
        surname: "",
        phone: "",
        agreementData: [],
        contactType: [],
        amount: this.amount,
        blik: "",
        cvv: "",
        cyy: "",
        cmm: "",
        pcard: "",
        payuAgreement: [],
      },
    };
  },

  validations() {
    if (this.subscription && this.showCreditCard) {
      return {
        form: {
          amount: {
            required,
            minValue: minValue(30),
            maxValue: maxValue(10000),
          },
          email: {
            required,
            email,
          },
          name: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          surname: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          agreementData: {
            required,
          },
          payuAgreement: {
            required,
          },
          cvv: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(3),
          },
          cyy: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(4),
            checkYear: (value) => {
              let toTest = parseInt(value, 10);
              let currentYear = new Date().getFullYear();
              if (toTest >= currentYear) {
                return true;
              } else {
                return false;
              }
            },
          },
          cmm: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(2),
            max12: (value) => {
              let toTest = parseInt(value, 10);
              if (toTest <= 12 && toTest > 0) {
                return true;
              } else {
                return false;
              }
            },
          },
          pcard: {
            required,
            mustBe16: (value) => {
              let toTest = value.replace(/\s+|-/g, "");
              if (toTest.length != 16) {
                return false;
              } else {
                return true;
              }
            },
            mustBeNumber: (value) => {
              let toTest = value.replace(/\s+|-/g, "");
              let reg = new RegExp("^[0-9]+$");
              if (reg.test(toTest)) {
                return true;
              } else {
                return false;
              }
            },
          },
        },
      };
    } else if (this.subscription) {
      return {
        form: {
          amount: {
            required,
            minValue: minValue(30),
            maxValue: maxValue(10000),
          },
          email: {
            required,
            email,
          },
          name: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          surname: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          agreementData: {
            required,
          },
        },
      };
    } else if (this.oneTimePayment && this.showBlikNum) {
      return {
        form: {
          amount: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(10000),
          },
          email: {
            required,
            email,
          },
          name: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          surname: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          agreementData: {
            required,
          },
          blik: {
            required,
            mustBeNumber: (value) => {
              let toTest = value.replace(/\s+|-/g, "");
              let reg = new RegExp("^[0-9]+$");
              if (reg.test(toTest)) {
                return true;
              } else {
                return false;
              }
            },
            mustBe6: (value) => {
              let toTest = value.replace(/\s+|-/g, "");
              if (toTest.length != 6) {
                return false;
              } else {
                return true;
              }
            },
          },
        },
      };
    } else {
      return {
        form: {
          amount: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(10000),
          },
          email: {
            required,
            email,
          },
          name: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          surname: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          agreementData: {
            required,
          },
        },
      };
    }
  },

  methods: {
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    },
    setTagVersion() {
      const cookieABvalue = getCookie("vue-ab-cookie");
      if(cookieABvalue === "test_ab_contentA") {
        this.abVersion = "testA";
      } else if(cookieABvalue === "test_ab_contentB") {
        this.abVersion = "testB";
      }else{
        this.abVersion = "testA";
      }
    },
    counterUp() {
      if (this.value < 4998) {
        this.value++;
        this.showAnimationFn();
      } else {
        this.value = 4999;
      }
    },
    counterDown() {
      if (this.value > 2) {
        this.value--;
      } else {
        this.value = 1;
      }
    },
    onClickElement: function (name) {
      window.trackFormClick(name);
    },
    onBlur: function () {
      this.form.pcard = this.form.pcard
        .replace(/\W/gi, "")
        .replace(/(.{4})/g, "$1 ")
        .substr(0, 19);
    },
    onBlurPhone: function () {
      this.form.phone = this.form.phone
        .replace(/[^\d\+]/g, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 15);
    },
    onEnterCreditCard: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }

      this.form.pcard = this.form.pcard
        .replace(/\W/gi, "")
        .replace(/(.{4})/g, "$1 ")
        .substr(0, 18);
    },
    onEnterPhone: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }

      this.form.phone = this.form.phone
        .replace(/\W/gi, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 13);
    },
    onEnterBlik: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }

      this.form.blik = this.form.blik
        .replace(/\W/gi, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 6);
    },
    onEnterMM: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      this.form.cmm = this.form.cmm.replace(/\W/gi, "").substr(0, 1);
    },
    onEnterYY: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      this.form.cyy = this.form.cyy.replace(/\W/gi, "").substr(0, 3);
    },
    onEnterCVV: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      this.form.cvv = this.form.cvv.replace(/\W/gi, "").substr(0, 2);
    },
    onCardPay() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.validationScrollToError();
        return;
      }
      this.showCreditCard = true;
      setTimeout(function () {
        document
          .getElementById("payByCard")
          .scrollIntoView({ behavior: "smooth" });
      }, 250);
    },
    onBlikPay() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.validationScrollToError();

        return;
      }
      this.showBlikNum = true;
    },
    onSubmit(evt) {
      let onSubmitButton = document.getElementById("onSubmitButton");
      if (onSubmitButton) {
        onSubmitButton.setAttribute("disabled", true);
        setTimeout(() => {
          onSubmitButton.removeAttribute("disabled");
        }, 2000);
        this.showBlikNum = false;
      }

      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "formSendError",
          formName: "Formularz Adoptuję",
          errorForm: "1",
        });

        this.validationScrollToError();
        return;
      }

      // rozpoznanie jaki button zostal klikniety, prymitywne obejscie, pewno bardoz nie vue
      // zrob to lepiej ;) bo ja nie znam vue wiec zrobilem taka ptoteze
      let type = "";
      if (evt.target.id === "payu-single-image") type = "payu";
      if (evt.target.id === "payu-subscription-image") type = "payu";
      if (evt.target.id === "paypal-image") type = "paypal";

      this.modalShow = false;
      this.showProgressBar = false;
      this.$router.push("/pending");

      if (this.subscription) {
        this.onSubscription(type);
      } else {
        this.onOneTime(type);
      }
    },
    onSubscription(type) {
      if (type === "paypal") {
        this.callWspieramApi(
          "https://api.adoptujpszczole.pl/api/payment/paypal/payment/recurring",
          this.getDataForPayment()
        );
      } else {
        // call via payByCard
        this.$router.push("/error");
      }
    },
    onOneTime(type) {
      let targetUrl;
      switch (type) {
        case "payu":
          targetUrl =
            "https://api.adoptujpszczole.pl/api/payment/payu/payment/choice";
          break;
        case "paypal":
          targetUrl =
            "https://api.adoptujpszczole.pl/api/payment/paypal/payment/single";
          break;
        case "blik":
          // blik but when we enter BLIK code on payu page
          targetUrl =
            "https://api.adoptujpszczole.pl/api/payment/payu/payment/blik";
          break;
      }
      this.callWspieramApi(targetUrl, this.getDataForPayment());
    },
    payByCard: function () {
      let buttonPayByCard = document.getElementById("payByCard");
      buttonPayByCard.setAttribute("disabled", true);
      setTimeout(() => {
        buttonPayByCard.removeAttribute("disabled");
      }, 2000);

      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.validationScrollToError();
        return;
      }

      console.log("paybycard called");
      //console.log('paybycard called');
      this.modalShow = false;
      this.showProgressBar = false;
      this.$router.push("/pending");

      // must be var!
      var dataForPayment = this.getDataForPayment();
      var router = this.$router;
      console.log("form", this.form);
      dataForPayment["card-expy"] = this.form.cyy;
      dataForPayment["card-expm"] = this.form.cmm;
      console.log("dataForPayment", dataForPayment);
      OpenPayU.merchantId = "191309";
      OpenPayU.Token.create(
        {
          allows_charges: true,
          allows_payouts: true,
        },
        function (payuResponse) {
          Fingerprint2.get({}, function (components) {
            var values = components.map(function (component) {
              return component.value;
            });
            var murmur = Fingerprint2.x64hash128(values.join(""), 31);

            console.log("Finerprint " + murmur);

            console.log("payu response", payuResponse);
            dataForPayment["mask"] = payuResponse.data.mask;
            dataForPayment["token"] = payuResponse.data.token;
            dataForPayment["type"] = payuResponse.data.type;
            dataForPayment["fingerprint"] = murmur;
            axios
              .post(
                "https://api.adoptujpszczole.pl/api/payment/payu/payment/recurring",
                dataForPayment,
                {
                  headers: { crossDomain: true },
                }
              )
              .then((response) => {
                console.log("get api response");
                console.log(response);

                if (response.data.redirectUri) {
                  window.location.href = response.data.redirectUri;
                } else {
                  if (response.data.status == "SUCCESS") {
                    router.push("/thankyou_regular");
                  } else if (response.data.status == "WARNING_CONTINUE_CVV") {
                    router.push("/error");
                  } else if (response.data.status == "ERROR_VALUE_INVALID") {
                    router.push("/error");
                  } else if (response.data.status == "WARNING_CONTINUE_3DS") {
                    window.location.href = response.data.redirectUri;
                  } else {
                    router.push("/error");
                  }
                }
              });
          });
        }
      );
    },
    payByBlik: function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.validationScrollToError();
        return;
      }
      let dataForPayment = this.getDataForPayment();
      dataForPayment.blik = this.form.blik;

      this.modalShow = false;
      this.showProgressBar = false;
      this.$router.push("/pending");
      window.goToPayment();
      this.callWspieramApi(
        "https://api.adoptujpszczole.pl/api/payment/payu/payment/blik",
        dataForPayment
      );
    },
    getDataForPayment() {
      return {
        landingPage: "ap11szkola",
        amount: this.form.amount,
        name: this.form.name,
        surname: this.form.surname,
        email: this.form.email,
        phone: this.form.phone,
        utmSource: new URLSearchParams(location.search).get("utm_source"),
        utmMedium: new URLSearchParams(location.search).get("utm_medium"),
        utmCampaign: new URLSearchParams(location.search).get("utm_campaign"),
        utmTerm: new URLSearchParams(location.search).get("utm_term"),
        utmContent: new URLSearchParams(location.search).get("utm_content"),
        fundraiser:
          this.form.fundraiser ??
          new URLSearchParams(location.search).get("fundraiser"),
        tag: this.abVersion,
        agreementData: this.form.agreementData.includes("agreementData"),
        agreementEmail: this.form.contactType.includes("agreementEmail"),
        agreementPhone: this.form.contactType.includes("agreementPhone"),
      };
    },
    callWspieramApi(targetUrl, dataForPayment) {
      window.goToPayment();
      axios
        .post(targetUrl, dataForPayment, {
          headers: { crossDomain: true },
        })
        .then((response) => {
          if (response.data.status == "SUCCESS") {
            window.location.href = response.data.redirectUri;
          } else {
            this.$router.push("/error");
          }
        });
    },
    showAnimationFn: function () {
      if (this.showAnimation != true) {
        this.showAnimation = true;
        setTimeout(() => {
          this.showAnimation = false;
        }, 8000);
      }
    },
    checkPaymentType: function () {
      window.clickAdoptujButton();

      if (this.oneTimePayment || this.subscription) {
        this.modalShow = true;
        window.trackAdoptionForm();
      } else {
        this.selectAdoptionType = true;
      }
    },
    validationScrollToError: function () {
      setTimeout(() => {
        if (document.body.clientWidth < 992) {
          let elementsInErrors =
            document.getElementsByClassName("text-danger-min");
          let elementsInErrorsName =
            document.getElementsByClassName("text-danger-name");
          if (elementsInErrors && elementsInErrors.length > 0) {
            let toScrollInput = document.getElementById("bee-counter-show");
            toScrollInput.scrollIntoView();
          } else if (elementsInErrorsName && elementsInErrorsName.length > 0) {
            let toScrollInputName = document.getElementById("name");
            toScrollInputName.scrollIntoView();
          }
        }
        if (!this.$v.form.surname.required) {
          window.errorOnFormField("surname", "Pole jest wymagane");
        } else if (!this.$v.form.surname.minLength) {
          window.errorOnFormField(
            "surname",
            "Minimalna długość nazwiska to 3 znaki"
          );
        } else if (!this.$v.form.surname.maxLength) {
          window.errorOnFormField(
            "surname",
            "Zbyt długie Nazwisko. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.name.required) {
          window.errorOnFormField("name", "Pole jest wymagane");
        } else if (!this.$v.form.name.minLength) {
          window.errorOnFormField(
            "name",
            "Minimalna długość imienia to 3 znaki"
          );
        } else if (!this.$v.form.name.maxLength) {
          window.errorOnFormField(
            "name",
            "Zbyt długie imię. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.email.required) {
          window.errorOnFormField("email", "Pole jest wymagane");
        } else if (!this.$v.form.email.email) {
          window.errorOnFormField("email", "Wpisz poprawny email");
        }
        if (!this.$v.form.agreementData.required) {
          window.errorOnFormField("agreementData", "Zgoda jest wymagana");
        }
        if (this.$v.form.payuAgreement) {
          if (!this.$v.form.payuAgreement.required) {
            window.errorOnFormField("payuAgreement", "Zgoda jest wymagana");
          }
        }
        if (this.$v.form.blik) {
          if (!this.$v.form.blik.required) {
            window.errorOnFormField("blik", "Padaj kod blik");
          } else if (
            !this.$v.form.blik.mustBeNumber ||
            !this.$v.form.blik.mustBe6
          ) {
            window.errorOnFormField("blik", "Padaj poprawny numer");
          }
        }
        if (this.$v.form.pcard) {
          if (!this.$v.form.pcard.required) {
            window.errorOnFormField("pcard", "Padaj kod blik");
          } else if (
            !this.$v.form.pcard.mustBeNumber ||
            !this.$v.form.pcard.mustBe16
          ) {
            window.errorOnFormField("pcard", "Padaj poprawny numer");
          }
        }
        if (this.$v.form.cvv) {
          if (!this.$v.form.cvv.required) {
            window.errorOnFormField("cvv", "Numer jest wymagany");
          } else if (
            !this.$v.form.cvv.minLength ||
            !this.$v.form.cvv.maxLength
          ) {
            window.errorOnFormField("cvv", "Padaj poprawny numer");
          }
        }
        if (this.$v.form.cmm) {
          if (!this.$v.form.cmm.required) {
            window.errorOnFormField("cmm", "Miesiąc jest wymagany");
          } else if (
            !this.$v.form.cmm.minLength ||
            !this.$v.form.cmm.maxLength ||
            !this.$v.form.cmm.max12
          ) {
            window.errorOnFormField("cmm", "Padaj poprawny miesiąc");
          }
        }
        if (this.$v.form.cyy) {
          if (!this.$v.form.cyy.required) {
            window.errorOnFormField("cyy", "Rok jest wymagany");
          } else if (
            !this.$v.form.cyy.minLength ||
            !this.$v.form.cyy.maxLength ||
            !this.$v.form.cyy.checkYear
          ) {
            window.errorOnFormField("cyy", "Padaj poprawny rok");
          }
        }
      }, 50);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    changedForm(e) {
      let dataToSend = e.target.name ? e.target.name : e.target.id;
      window.formFieldClick(dataToSend);
    },
    showTooltipButonSubFn() {
      this.showTooltipButonSub = false;
    },
  },
  watch: {
    value: function () {
      this.value = Math.floor(this.value);
      if (isNaN(this.value)) {
        console.log("not a number");
        this.value = 0;
      }
      if (this.value > 0) {
        if (this.value > 5000) {
          this.value = 5000;
        }
        this.amount = 2 * parseFloat(this.value);
        this.form.amount = 2 * parseFloat(this.value);
      } else {
        this.amount = 0;
        this.form.amount = 0;
      }
      window.formFieldClick("bee-counter");
    },
    subscription: function () {
      if (this.subscription) {
        this.oneTimePayment = false;
        this.showBlikNum = false;
      } else {
        this.oneTimePayment = true;
        this.showCreditCard = false;
      }
    },
    oneTimePayment: function () {
      if (this.oneTimePayment) {
        this.subscription = false;
      } else {
        this.subscription = true;
      }
    },
    modalShow: function () {
      const pageTitle = document.title;
      if (this.modalShow) {
        document.title = "Adoptuj pszczołę 10" + " | " + "Formularz adopcji";
      } else {
        document.title =
          "Adoptuj pszczołę 10" +
          " | " +
          "Adoptuj pszczołę i twórz z nami Polskę przyjazną zapylaczom";
      }
    },
  },

  components: {
    CountDown,
    ProgressBar,
    Animation,
    Ab,
  },
  props: {
    thanks: Boolean,
  },
  mounted() {
    this.setTagVersion();
    let inviteToPay = new URLSearchParams(location.search).get("inviteToPay");
    let inviteToSinglePayment = new URLSearchParams(location.search).get(
      "inviteToSinglePayment"
    );

    let fundraiser = new URLSearchParams(location.search).get("fundraiser");
    let utmSource = new URLSearchParams(location.search).get("utm_source");
    let utmMedium = new URLSearchParams(location.search).get("utm_medium");
    let utmCampaign = new URLSearchParams(location.search).get("utm_campaign");
    let utmTerm = new URLSearchParams(location.search).get("utm_term");
    let utmContent = new URLSearchParams(location.search).get("utm_content");
    let tag = this.abVersion;

    if (inviteToPay) {
      this.hideSingle = true;
      this.modalShow = true;
      if (inviteToPay > 0) {
        this.subscription = true;
        this.value = inviteToPay;
        this.oneTimePayment = false;
        // this.form.value = inviteToPay;
        this.amount = inviteToPay * 2;
        this.form.amount = inviteToPay * 2;
      }
    }
    if (inviteToSinglePayment) {
      if (inviteToSinglePayment > 0) {
        this.modalShow = true;
        this.subscription = false;
        this.oneTimePayment = true;
        this.value = inviteToSinglePayment;
        this.amount = inviteToSinglePayment * 2;
        this.form.amount = inviteToSinglePayment * 2;
      }
    }

    this.remarketingWelcome = fundraiser === "ap11re"; //test

    axios
      .get("https://api.adoptujpszczole.pl/api/counter/ap11", {
        headers: { crossDomain: true },
      })
      .then((response) => {
        this.counterNum = response.data.counter;
        this.counter = response.data.counter
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        this.showProgressBar = true;
      });
    this.form.amount = 2 * parseFloat(this.value);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
